import React, { Component } from "react";

import FilterDropDown from "../components/FilterDropDown";
import ApprovalAllButton from "./ApprovalAllButton";

export default class OutstandingLeavesFilters extends Component {
  get leaveCategoryDropDownList() {
    const list = this.props.leaveCategories.map((category) => {
      return {
        value: category.leave_category_id,
        label: category.leave_category,
      };
    });
    list.unshift({ label: "ALL", value: 0 });
    return list;
  }

  get currentFilterNames() {
    const names = [];
    const {
      selectedLeaveCategory,
      selectedLeaveStatus,
      selectedDesignation,
      selectedDepartment,
      selectedBranch,
      selectedRegion,
    } = this.props.currentFilters;

    if (selectedLeaveCategory !== 0) {
      names.push({
        key: "Leave Category",
        value: this.props.leaveCategories.find(
          (leaveCategory) =>
            leaveCategory.leave_category_id === selectedLeaveCategory
        )["leave_category"],
      });
    }

    if (selectedLeaveStatus !== 0) {
      names.push({
        key: "Leave Status",
        value: this.props.leaveApplicationStatusList.find(
          (status) => status.value === selectedLeaveStatus
        )["label"],
      });
    }

    if (selectedDesignation !== 0) {
      names.push({
        key: "Designation",
        value: this.props.designations.find(
          (designation) => designation.value === selectedDesignation
        )["label"],
      });
    }

    if (selectedDepartment !== 0) {
      names.push({
        key: "Department",
        value: this.props.departments.find(
          (dept) => dept.value === selectedDepartment
        )["label"],
      });
    }

    if (selectedBranch !== 0) {
      names.push({
        key: "Branch",
        value: this.props.branches.find(
          (branch) => branch.value === selectedBranch
        )["label"],
      });
    }

    if (selectedRegion !== 0) {
      names.push({
        key: "Region",
        value: this.props.regions.find(
          (region) => region.value === selectedRegion
        )["label"],
      });
    }

    return names;
  }

  handleLeaveCategory = (val) => {
    this.props.handleFilterValue("selectedLeaveCategory", val);
  };

  handleLeaveStatus = (val) => {
    this.props.handleFilterValue("selectedLeaveStatus", val);
  };

  handleDesignation = (val) => {
    this.props.handleFilterValue("selectedDesignation", val);
  };

  handleDepartment = (val) => {
    this.props.handleFilterValue("selectedDepartment", val);
  };

  handleBranch = (val) => {
    this.props.handleFilterValue("selectedBranch", val);
  };

  handleRegion = (val) => {
    this.props.handleFilterValue("selectedRegion", val);
  };

  handleEmployeeName = (val) => {
    this.props.handleFilterValue("selectedEmployee", val);
  };

  render() {
    return (
      <div
        style={{
          marginTop: 20,
          marginBottom: 35,
          alignItems: "end",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <FilterDropDown
          label="Leave Category"
          dropDownList={this.leaveCategoryDropDownList}
          handleSelect={this.handleLeaveCategory}
        />
        <FilterDropDown
          label="Leave Status"
          dropDownList={this.props.leaveApplicationStatusList}
          handleSelect={this.handleLeaveStatus}
        />
        <FilterDropDown
          label="Designation"
          dropDownList={this.props.designations}
          handleSelect={this.handleDesignation}
        />
        <FilterDropDown
          label="Department"
          dropDownList={this.props.departments}
          handleSelect={this.handleDepartment}
        />
        <FilterDropDown
          label="Branch"
          dropDownList={this.props.branches}
          handleSelect={this.handleBranch}
        />
        <FilterDropDown
          label="Region"
          dropDownList={this.props.regions}
          handleSelect={this.handleRegion}
        />
        <FilterDropDown
          label="Employee Name"
          dropDownList={this.props.employees}
          handleSelect={this.handleEmployeeName}
        />

        {/* Placeholders */}
        {[1, 2, 3].map((_) => {
          return (
            <div
              className="col-lg-3 col-md-6 col-sm-12"
              style={{
                paddingLeft: "0",
                paddingRight: "0",
                marginBottom: "10px",
              }}
            ></div>
          );
        })}

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            width: "500px",
            marginTop: "20px",
          }}
        >
          <ApprovalAllButton
            label={"Approve All"}
            action={this.props.approveLeaves}
            dialogPurpose={"Approve"}
            filteredLeaves={this.props.filteredLeaves}
            mainColor={"#29a50a"}
            currentFilterNames={this.currentFilterNames}
          />
          <div
            style={{
              width: "30px",
            }}
          ></div>
          <ApprovalAllButton
            label={"Reject All"}
            action={this.props.rejectLeaves}
            dialogPurpose={"Reject"}
            filteredLeaves={this.props.filteredLeaves}
            mainColor={"#f60e2f"}
            currentFilterNames={this.currentFilterNames}
          />
        </div>
      </div>
    );
  }
}
